import styled from 'styled-components';

export const CustomSpinner = styled.div`
  border: 7px solid #f0f1f5;
  border-top: 7px solid #7d70d2;
  border-radius: 50%;
  width: 38px;
  height: 38px;
  animation: spin 0.8s linear infinite;

  @keyframes spin {
    0% {
      transform: rotate(0deg);
    }
    100% {
      transform: rotate(360deg);
    }
  }
`;
